<template>
  <div class="link-views white-bg">
    <div class="top">
      <Button type="primary" @click="addItemFn">添加</Button>
    </div>
    <div class="table-div">
      <!-- 表格 -->
      <Table :columns="columns" :data="listObj.Result" :loading="loading">
        <template slot-scope="{ index }" slot="Index">
          <div>{{(listObj.page-1)*(pageData.size)+(index+1)}}</div>
        </template>
        <template slot-scope="{ row }" slot="img">
          <div class="rotationImg">
            <img :src="port+row.ImgUrl">
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <div class="action-table">
            <a @click="editItemFn(row)">编辑</a>
            <a @click="delItemFn(index,row)">删除</a>
          </div>
        </template>
      </Table>
      <!-- 分页 -->
      <div class="page-div">
        <Page
          :total="listObj.records"
          :current="pageData.page"
          :page-size="pageData.size"
          @on-change="changePage"
        />
      </div>
    </div>
    <!-- 编辑模态框 -->
    <Modal v-model="showModal" :mask-closable="false" title="编辑轮播图">
      <Form ref="editItem" :model="editItem" :rules="ruleValidate" :label-width="80">
        <FormItem label="类型" prop="TypeId" v-if="isAdd">
          <i-select v-model="editItem.TypeId">
            <i-option
              v-for="item in ImageTypeList"
              :value="item.TypeId"
              :key="item.TypeId"
            >{{ item.TypeName }}</i-option>
          </i-select>
        </FormItem>
        <FormItem label="图片" prop="ImgUrl">
          <myUpload
            v-if="showModal"
            :defaultList="defaultList"
            :isImg="'img'"
            @getUrlList="getUrlArr"
          ></myUpload>
        </FormItem>
        <FormItem label="跳转链接" prop="SkipUrl">
          <Input v-model="editItem.SkipUrl"/>
        </FormItem>
        <FormItem label="标题" prop="Title">
          <Input v-model="editItem.Title"/>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="showModal=false">取消</Button>
        <Button type="primary" @click="sureEdit('editItem')">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import * as homeConst from "../../../apiconfig/index.js";
import * as homeApi from "../../../api/home-api.js";
import myUpload from "../../../components/my-upload";
export default {
  name: "slideshow",
  components: { myUpload },
  data() {
    return {
      port: homeConst.baseUrl + "/", //baseurl
      loading: true, //无数据显示加载中
      showModal: false, //显示编辑模态框
      isAdd: true, //添加或编辑
      editItem: {}, //操作项目详情
      ImageTypeList: [], //轮播图类别列表
      listObj: {}, //根据分页条数获取数据详情
      pageData: {
        //分页条数
        page: 1,
        size: 4
      },
      columns: [
        //设置表格参数
        {
          title: "序号",
          slot: "Index",
          width: 80,
          align: "center"
        },
        {
          title: "类型",
          key: "TypeName",
          align: "center"
        },
        {
          title: "图片",
          slot: "img",
          align: "center"
        },
        {
          title: "跳转链接",
          key: "SkipUrl",
          align: "center"
        },
        {
          title: "标题",
          key: "Title",
          align: "center"
        },
        {
          title: "可选操作",
          slot: "action",
          align: "center"
        }
      ],
      ruleValidate: {
        TypeId: [{ required: true, message: "选择轮播图类型", type: "number" }],
        ImgUrl: [
          { required: true, message: "轮播图图片不能为空", trigger: "change" }
        ],
        SkipUrl: [
          { required: true, message: "跳转链接不能为空", trigger: "blur" }
        ],
        Title: [
          { required: true, message: "轮播图标题不能为空", trigger: "blur" }
        ]
      },
      // headers: {
      //   enctype: "multipart/form-data",
      //   Token: sessionStorage.getItem("token")
      // },
      defaultList: []
    };
  },
  computed: {},

  mounted() {
    this.getDataList(); // 获取轮播图列表
    this.GetSchoolImageTypeList();
  },
  methods: {
    // 获取轮播图列表
    async getDataList() {
      this.listObj = await homeApi.GetSchoolImageList({
        page: this.pageData.page ? this.pageData.page : 1,
        size: this.pageData.size ? this.pageData.size : 4
      });
      this.loading = false;
    },
    //获取轮播图类别列表
    async GetSchoolImageTypeList() {
      this.ImageTypeList = await homeApi.GetSchoolImageTypeList();
    },

    // 显示模态框，添加功能
    addItemFn() {
      this.isAdd = "AddSchoolImage";
      this.editItem = {};
      this.defaultList = [];
      this.$refs["editItem"].resetFields();
      this.showModal = true;
      this.pageData.page = 1;
    },
    //显示模态框，修改功能
    editItemFn(row) {
      this.$refs["editItem"].resetFields();
      this.editItem = JSON.parse(JSON.stringify(row));
      this.defaultList = [{ url: this.editItem.ImgUrl }];
      this.isAdd = "AmendSchoolImageById";
      this.showModal = true;
    },
    // 确定编辑项目
    sureEdit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          homeApi[this.isAdd](this.editItem).then(res => {
            if (res.success) {
              this.getDataList();
              this.showModal = false;
              this.$Message.success({
                content: res.msg,
                duration: 3
              });
            } else {
              this.$Message.error({
                content: res.msg,
                duration: 3
              });
            }
          });
        } else {
          this.$Message.error({
            content: "数据不符合要求",
            duration: 3
          });
        }
      });
    },
    // 删除项目
    delItemFn(index, row) {
      this.$Modal.confirm({
        title: "删除轮播图",
        content: "确认删除" + row.Title,
        onOk: () => {
          homeApi.DelSchoolImage({ ImageId: row.ImageId }).then(res => {
            if (res.success) {
              this.pageData.page = 1;
              this.getDataList();
              this.$Message.success({
                content: res.msg,
                duration: 3
              });
            } else {
              this.$Message.error({
                content: res.msg,
                duration: 3
              });
            }
          });
        },
        onCancel: () => {}
      });
    },
    // 分页
    changePage(page) {
      this.pageData.page = page;
      this.getDataList();
    },
    //图片上传
    getUrlArr(val) {
      this.editItem.ImgUrl = val[val.length - 1].url;
    }
  }
};
</script>

<style scoped>
</style>